const gridStyle = {
  grid: {
    margin: '0 -15px !important',
    width: 'unset'
  }
};

export default gridStyle;
